import axios from 'axios';
import { API_CONFIG } from '../config/apiConfig.js';

// Create axios instance with proper base URL configuration
const createApiInstance = () => {
  // console.log('🌐 API Base URL:', API_CONFIG.BASE_URL);
  
  return axios.create({
    baseURL: API_CONFIG.BASE_URL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': 'true',
    },
  });
};

// Create the API instance
const api = createApiInstance();

// Export the configured axios instance
export default api;

// Export individual methods for convenience
export const apiGet = (url, config = {}) => api.get(url, config);
export const apiPost = (url, data = {}, config = {}) => api.post(url, data, config);
export const apiPut = (url, data = {}, config = {}) => api.put(url, data, config);
export const apiDelete = (url, config = {}) => api.delete(url, config);
